var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):(_vm.url)?_c('a',{attrs:{"href":_vm.url}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('span',[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }